import React from 'react';
import Step7CardApp from '../Functionality/Step7CardApp';
import CardItem from '../SubComponents/CardItem';
import CustomAvailableItems from '../../../../../components/CustomAvailableAssignedItems/CustomAvailableItems';
import { IconIdentificationCard } from '../../../../../components/buttons/IconButtons';
import { ACTION_MODEL } from './../../../../../Helpers/ActionModel';
import {SimpleSearch} from "../../../../../reduxToolkit/Search/SearchApi";
import {SEARCH_MODEL} from "../../../../../components/table/Model/TableModel";
import {TABLES} from "../../../../../Apis/Tables";
import {filterCards} from "../../../../../Apis/functions";
/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */
const Step7Card = ({ userData, componentAction, cardsList, setCardsList }) => {
    const {
        searchElement,
        setSearchElement,
        results,
        setResults,
        setSimpleSearch,
        setSearch,
        t,
        modified,
        setModified,
        handleAddCard,
        handleUnassingCard
    } = Step7CardApp({
        componentAction,
        userData
    });

    return (
        <div className={"border-radius-8px border-full-shades-300 py-3"}>
            <CustomAvailableItems
                results={results}
                setResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                labelRowsPerPage={'cards_per_page'}
                tableNotInformationLegend={'no_cards_available'}
                selectedSectionNotInformationLegend={'no_cards_added_yet'}
                selected={cardsList}
                setSelected={setCardsList}
                onDelete={handleUnassingCard}
                keyId={'id'}
                tableTitle=''
                selectedSectionIconTitle={<IconIdentificationCard />}
                selectedSectionTitle='assigned_cards'
                searchTitle={"search_by_number_code_or_format"}
                tableBuildBody={({ page, rowsPerPage, searchElement }) => ({ body: SEARCH_MODEL.setObject({
                    page: page,
                    size: rowsPerPage,
                    key: searchElement,
                    model: TABLES.CARD_AVAILABLE
                }) })}
                tableEndPoint={SimpleSearch}
                viewTypeName={'cards'}
                bottom={100}
                modified={modified}
                setModified={setModified}
                renderAvailableItem={({ item, onAdd }) => (
                    <CardItem
                        card={item}
                        t={t}
                        isAssigned={false}
                        onAdd={() => {
                            if (componentAction === ACTION_MODEL.UPDATE && !handleAddCard(item)) return;
                            onAdd(item);
                        }}
                        disabled={cardsList.some((c) => c.id === item.id)}
                    />
                )}
                renderSelectedItems={({ items, selectedSearchElement, handleDelete }) =>
                    filterCards(items, selectedSearchElement).map((card) => (
                        <div className='mb-2' key={card.id}>
                            <CardItem
                                card={card}
                                t={t}
                                isAssigned={true}
                                onRemove={() => handleDelete(card)}
                                disabled={false}
                            />
                        </div>
                    ))
                }
            />
        </div>
    );
};
export default Step7Card;
